import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const ListPage = lazy(() => import('./pages/ListPage'));
const NewEditPage = lazy(() => import('./pages/NewEditPage'));
const SubscribersPage = lazy(() => import('./pages/SubscribersPage'));

// ----------------------------------------------------------------------

export const clubRoutes = {
  path: 'club',
  children: [
    { element: <ListPage />, index: true },
    { path: 'new', element: <NewEditPage /> },
    { path: ':id/edit', element: <NewEditPage /> },
    { path: 'subscribers/:ids', element: <SubscribersPage /> },
  ],
};
